<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main box-panel shadow max-w max-gm" id="page-content-main">
    <div class="m--pa4" style="max-height: 30rem; overflow-y:scroll" tabindex="0">

      <h2>Privacy Statement</h2>
      <i class="text-muted">Last Updated: 01/10/2023</i>
      <hr>

      SMI Pay LLC, (“<STRONG>MO Child Support Internet Payment Website</STRONG>”, “<STRONG>we</STRONG>”, “<STRONG>us</STRONG>”, or “<STRONG>our</STRONG>” as applicable) 
      respects and protects the privacy of visitors to our website and users of our internet payment services. This Privacy Policy describes our information handling 
      practices when you access our website or use MO CHILD SUPPORT INTERNET PAYMENT WEBSITE to make a payment. Capitalized terms used herein and not defined are defined 
      in our <a [routerLink]="['/termsandconditions']"><u>Terms and Conditions</u></a>. <br />
      <br />

      Please take a moment to read this Privacy Policy carefully. If you have any questions about this Privacy Policy, please submit your request by calling 1-888-761-3665 
      during customer service hours. The hours are Monday-Friday, 8:00 a.m. to 5:00 p.m., Central Standard Time (CST), excluding state 
      and federal holidays. By accessing and using our website or MO CHILD SUPPORT INTERNET PAYMENT WEBSITE to make a payment, you signify acceptance to the terms of this 
      Privacy Policy. Where we require your consent to process your personal information, we will ask for your consent to the collection, use, and disclosure of your 
      personal information as described further below. <br />
      <br />
      
      If you do not agree with or you are not comfortable with any aspect of this Privacy Policy, you should immediately discontinue using MO CHILD SUPPORT INTERNET PAYMENT 
      WEBSITE and accessing our website. <br />
      <br />
      
      Please note that while we have taken reasonable steps to safeguard the integrity of the information that we collect and store, along with preventing unauthorized 
      access to information maintained by us, given the inherent nature of technology and the internet, no security measures can ever be assumed to be 100% fail-safe. <br />
      <br />

      We may provide you with additional disclosures about the information processing practices of specific services. These notices may supplement or clarify our 
      privacy practices or may provide you with additional choices about how we process your information. To keep up with changing legislation, best practice and changes 
      in how we process personal information, we reserve the right to amend this Privacy Policy at any time without notice by posting a revised version on our website. To 
      stay up to date on any changes, check back periodically. <br />
      <br />

      <STRONG>1.	Information we may collect or receive</STRONG>
      <br>

      Personal information is data that identifies an individual or relates to an identifiable individual. This includes information you provide to us, information which 
      is collected about you automatically, and information we obtain from third parties. The definition of personal information depends on the applicable law based on 
      your physical location. Only the definition that applies to your physical location will apply to you under this Privacy Policy. <br />
      <br />

      <STRONG>1.1	Information you provide to us </STRONG>
      <br>

      You may give us information about you when you sign up to use MO CHILD SUPPORT INTERNET PAYMENT WEBSITE. This also includes information you provide tbrough your 
      continued use of MO CHILD SUPPORT INTERNET PAYMENT WEBSITE, such as how you use our website, and information you provide when you report a problem related to a 
      Payment Instruction or our services. We may collect the following types of information from you: <br />
      <br />

      <ul class="list-bullet mx-3">
        <li>
          <STRONG>Personal Identification Information:</STRONG> such as your full name, date of birth, geographic location information, phone number, home address, 
          and/or email. <br />
        </li>

        <li>
          <STRONG>Financial Information:</STRONG> such as Bank Account information (savings or checking number and routing number), Card account number and related 
          details. <br />
        </li>

        <li>
          <STRONG>Transaction/Child Support File Information:</STRONG> such as information about the transactions you make using our website, such as your name, the 
          amount, and/or timestamp, as well as the relevant Child Support file, associated with your Payment Instruction. <br />
        </li>

        <li>
          <STRONG>Correspondence:</STRONG> such as information provided to our Customer Service team.
        </li>
      </ul>
      <br />

      If you provide to us the personal information of any individual other than yourself during your use of our services, you certify that you have obtained consent 
      from such individual to disclose such information to us, as well his/her consent to our collection, use and disclosure of such personal information, for the 
      purposes set out in this Privacy Policy. <br />
      <br />

      <STRONG>1.2	Other information we may collect </STRONG>
      <br>

      To the extent permitted under the applicable law, we may collect certain types of information automatically, such as information about when you interact with our 
      website or use MO CHILD SUPPORT INTERNET PAYMENT WEBSITE (e.g., the date and time and the web pages or services you accessed during your visit). We may also use 
      identifiers to recognize you when you access our websites via an external link, such as a link appearing on a third-party website. This type of information helps 
      us address customer support issues, improve the performance of our websites, and provide you with a streamlined and personalized experience. Information collected 
      automatically includes: <br />
      <br />

      <ul class="list-bullet mx-3">
        <li>
          <STRONG>Online Identifiers:</STRONG> Geo location/tracking details, browser fingerprint, operating system, browser name and version, and/or your IP addresses.
        </li>

        <li>
          <STRONG>Usage Data:</STRONG> Authentication data, security questions, click-stream data, and other data collected via cookies and similar technologies. Please read about Cookies in Section 5 below for more information.
        </li>

        <li>
          <STRONG>Customer Service:</STRONG> Calls may be recorded.
        </li>
      </ul>
      <br />

      <STRONG>1.3	Information we may receive from other sources </STRONG>
      <br>

      From time to time, we may obtain information about you from third party sources as required or permitted by applicable law. These sources may include: <br />
      <br />

      <ul class="list-bullet mx-3">
        <li>
          <STRONG>Public Databases</STRONG>
        </li>

        <li>
          <STRONG>Payment Service Providers</STRONG>
        </li>

        <li>
          <STRONG>Advertising Networks & Analytics Providers</STRONG>
        </li>

        <li>
          <STRONG>Government Agencies</STRONG> with information such as a case number or social security number
        </li>

      </ul>
      <br />

      <STRONG>2.	Uses made of information we collect or receive </STRONG>
      <br>

      Our primary purpose in collecting personal information is to provide you with our services in a secure, smooth manner. We may use this information in 
      the following ways: <br />
      <br />

      <STRONG>2.1	To provide MO CHILD SUPPORT INTERNET PAYMENT WEBSITE’s services to you</STRONG>
      <br>

      We process your personal information to provide payment services to you. Third parties such as Payment Service Providers may also access and/or collect 
      your personal information when providing fraud prevention or other services. We cannot provide you with services without such information. <br />
      <br />

      <STRONG>2.2	To provide service-related communications</STRONG>
      <br>

      We send administrative or payment and account-related information to you to keep you updated about our Services, inform you of relevant security issues or 
      updates, or provide other transaction-related information. You may not opt-out of receiving critical service communications, such as emails or mobile 
      notifications sent for legal or security purposes. <br />
      <br />

      <STRONG>2.3	To provide customer support</STRONG>
      <br>

      We process your personal information when you contact us to resolve any questions or to troubleshoot problems. Without processing your personal information for 
      such purposes, we cannot respond to your questions and ensure your uninterrupted use of our services. <br />
      <br />

      <STRONG>2.4	To ensure network and information security and quality control</STRONG>
      <br>

      We process your personal information in order to enhance security, monitor and verify identity or service access, combat spam or other malware or security 
      risks and to comply with applicable security laws and regulations. We also process your personal information for quality control and staff training. If we 
      do not process personal information for quality control purposes, you may experience issues with the services and/or we may not be able to ensure the security 
      of our services. <br />
      <br />

      <STRONG>2.5	For research and development purposes and to enhance your experience</STRONG>
      <br>

      We process your personal information to better understand the way you use and interact with MO CHILD SUPPORT INTERNET PAYMENT WEBSITE. Without such processing, 
      we cannot ensure your smooth use of MO CHILD SUPPORT INTERNET PAYMENT WEBSITE functionality. <br />
      <br />

      <STRONG>2.6	To engage in marketing activities</STRONG>
      <br>

      Based on your communication preferences, we may send you marketing communications (e.g., emails) to inform you about our services. Our marketing will be 
      conducted in accordance with your advertising marketing preferences and as permitted by applicable law. <br />
      <br />

      <STRONG>2.7	To maintain legal and regulatory compliance</STRONG>
      <br>

      Some of our services or services provided by Payment Service Providers are subject to laws and regulations requiring us to collect, use, and store your personal 
      information in certain ways. When you seek debit your Bank Account or use a Card, we may require you to provide additional information which we may use in collaboration 
      with Payment Service Providers to verify your identity or address, and/or to manage risk as required under applicable law. The consequences of not processing your 
      personal information for such purposes is the termination of your ability to use MO CHILD SUPPORT INTERNET PAYMENT WEBSITE. <br />
      <br />

      <STRONG>2.8	To enforce our terms in our user agreement and other agreements</STRONG>
      <br>

      We monitor to prevent any prohibited or illegal activities on our website, enforce our agreements with third parties, and/or prevent and detect violations of our Terms 
      and Conditions. We collect information about your usage and closely monitor your interactions with us. We may use any of your personal information collected for these 
      purposes. The consequences of not processing your personal information for such purposes is the termination of your ability to use MO CHILD SUPPORT INTERNET PAYMENT 
      WEBSITE. <br />
      <br />

      <STRONG>2.9	For any purpose</STRONG>
      <br>

      We may disclose your personal information for any purpose you consent to. <br />
      <br />

      The following chart summarizes how we use the categories of personal information we collect from you: <br />
      <br />

      <table class="table table-sm" tabindex="0">
        <thead class="table-light">
          <tr>
            <th>Personal Information Category, as described above</th>
            <th>Sources of Such Personal Information</th>
            <th>Purpose of Collection of Such Personal Information</th>
            <th>Disclosure of Personal Information</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>(A) Identifiers such as Personal Identification Information</td>
            <td>Information you provide us; Information collected from third parties</td>
            <td>Section 2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, and 2.8 above </td>
            <td>
              <ul class="list-bullet">
                <li>Payment Service Providers</li>
                <li>Service providers</li>
                <li>Professional advisors</li>
              </ul>
            </td>
          </tr>

          <tr>
            <td>(B) Customer records such as signature</td>
            <td>Information you provide us; Information collected from third parties</td>
            <td>Section 2.2, 2.3, 2.5, 2.7 and 2.8 above</td>
            <td>
              <ul class="list-bullet">
                <li>Payment Service Providers</li>
                <li>Service providers</li>
              </ul>
            </td>
          </tr>

          <tr>
            <td>C) Protected classifications under California and federal law, such as age</td>
            <td>Information you provide us; Information collected from third parties</td>
            <td>Section 2.7 and 2.8 above</td>
            <td>
              <ul class="list-bullet">
                <li>Professional advisors</li>
              </ul>
            </td>
          </tr>

          <tr>
            <td>(D) Commercial information such as records of services purchased, obtained, or considered</td>
            <td>Information you provide us; Information we collect from you automatically;</td>
            <td>Section 2.1, 2.2, 2.3, 2.4, 2.5, 2.6 and 2.8 above</td>
            <td>
              <ul class="list-bullet">
                <li>Payment Service Providers</li>
                <li>Service providers</li>
                <li>Professional advisors</li>
              </ul>
            </td>
          </tr>

          <tr>
            <td>(E) Biometric information</td>
            <td><i class="text-muted">Not Applicable</i></td>
            <td><i class="text-muted">Not Applicable</i></td>
            <td><i class="text-muted">Not Applicable</i></td>
          </tr>

          <tr>
            <td>(F) Usage Data</td>
            <td>Information we collect from you automatically</td>
            <td>Section 2.3, 2.4, 2.5, 2.6, 2.7 and 2.8 above</td>
            <td>
              <ul class="list-bullet">
                <li>Payment Service Providers</li>
                <li>Service providers</li>
                <li>Professional advisors</li>
              </ul>
            </td>
          </tr>

          <tr>
            <td>(G) Online Identifiers</td>
            <td>Information we collect from you automatically</td>
            <td>Section 2.1, 2.5, 2.7 and 2.8 above</td>
            <td>
              <ul class="list-bullet">
                <li>Payment Service Providers</li>
                <li>Service providers</li>
                <li>Professional advisors</li>
              </ul>
            </td>
          </tr>

          <tr>
            <td>(H) Sensory data, such as audio, electronic, visual information</td>
            <td>Information you provide us; Information we collect from you automatically</td>
            <td>Section 2.1, 2.2, 2.3, 2.4, 2.5 and 2.8 above</td>
            <td>
              <ul class="list-bullet">
                <li>Professional advisors</li>
              </ul>
          </tr>

          <tr>
            <td>(I) Professional or employment-related information</td>
            <td><i class="text-muted">Not collected</i></td>
            <td><i class="text-muted">Not Applicable</i></td>
            <td><i class="text-muted">Not Applicable</i></td>
          </tr>

          <tr>
            <td>(J) Inferences about preferences, characteristics, predispositions, etc.</td>
            <td><i class="text-muted">Not collected</i></td>
            <td><i class="text-muted">Not Applicable</i></td>
            <td><i class="text-muted">Not Applicable</i></td>
          </tr>
        </tbody>
      </table>
      <br />

      We will not use your personal information for purposes other than those purposes we have disclosed to you, without your permission. <br />
      <br />

      <STRONG>3.	Disclosure of your information</STRONG>
      <br>

      It is our policy to treat all personal and transaction information as confidential. This means that we will not sell or rent your personal information to third 
      parties without your consent. However, we may disclose information to third parties about you and/or the transactions you make, in the following situations: <br />
      <br />

      <STRONG>3.1 Where it is necessary for completing transactions</STRONG>, such as to Payment Service Providers or other financial institutions with which we partner 
      to process payments you have authorized.
      <br>

      <ul class="list-bullet mx-3">
        <li>
          Your Card information, if you use such methods to make payments on our website, is securely transferred and hosted off-site by Payment Service Providers 
          and is held in compliance with Payment Card Industry Data Security Standards (PCI DSS). <br />
        </li>

        <li>
          When using MO CHILD SUPPORT INTERNET PAYMENT WEBSITE online you may be linked to other websites, such as those of other Payment Service Providers, and other 
          third parties that are not operated by us. We strongly advise you to review the Privacy Policy of every such party. We have no control over, and assume no 
          responsibility for the content, privacy policies or practices of any third-party websites or services; <br />
        </li>
      </ul>
      <br />

      <STRONG>3.2</STRONG> Where required by law;
      <br><br>

      <STRONG>3.3</STRONG> With professional advisors who provide banking, legal, compliance, insurance, accounting, or other consulting services in order to complete 
      third party financial, technical, compliance and legal audits of our operations or otherwise comply with our obligations;
      <br><br>

      <STRONG>3.4</STRONG>	With service providers under contract with us who help with parts of our business operations. Our contracts require these service providers to 
      only use your information in connection with the services they perform for us and prohibit them from selling your information to anyone else. Examples include our cloud 
      storage providers, customer support providers, network infrastructure and security providers; and
      <br><br>

      <STRONG>3.5	If you give us your written permission.</STRONG>
      <br>

      The personal information that you submit, to us may become part of the child support file, however, all child support files are confidential. <br />
      <br />

      <STRONG>4.	Retention of Personal Information</STRONG>
      <br>

      We will only retain your personal information for as long as necessary to fulfil the purposes for which we collected it, including for the purposes of 
      satisfying any legal, accounting, or reporting obligations or to resolve disputes. We generally store information for up to 7 years. <br />
      <br />

      <STRONG>5.	Cookies</STRONG>
      <br>

      MO CHILD SUPPORT INTERNET PAYMENT WEBSITE may use cookies on its website to distinguish you from other users. This helps us to provide you with a good experience 
      and also allows us to improve our services. Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to 
      your browser from a website and transferred to your device. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The 
      “Help” feature on most browsers provides information on how to accept cookies, disable cookies or to notify you when receiving a new cookie. <br />
      <br />

      <STRONG>Other</STRONG>
      <br>

      This PRIVACY NOTICE IS FOR CALIFORNIA RESIDENTS ONLY and supplements the Privacy Policy above. <br />
      Effective January 1, 2020, the California Consumer Act of 2018 (the “CCPA”) permits consumers who are California residents to ask businesses covered under the 
      CCPA about personal information it has collected about the consumer, submit an access or deletion request, and opt-out of the sale of personal information, if applicable. <br />
      <br />

      <ul class="list-bullet mx-3">
        <li>
          You have the right to request that we disclose certain information to you about our collection and use of your personal information over the past 12 months. 
          We have not sold any of your personal information in the last 12 months. <br />
        </li>

        <li>
          You have the right to request access to or that we delete any of your personal information that we collected from you and retained, subject to certain exceptions. 
          Once we receive and confirm your verifiable consumer request, we will delete (and direct our service providers to delete) your personal information from our 
          records or provide it to you, as applicable, unless an exception applies. <br />
        </li>
      </ul>
      <br />

      If you have any questions or comments about this notice, our Privacy Policy, the ways in which we collect and use your personal information, your choices and rights 
      regarding such use, or wish to exercise your rights under California law, please do not hesitate to contact us at 1-888-761-3665
      during customer service hours. The hours are Monday-Friday, 8:00 a.m. to 5:00 p.m., Central Standard Time (CST), excluding state and federal holidays. Or by mail at MO 
      State Disbursement Unit, P. O. Box 109006, Jefferson City, MO 65110-9006. We will not discriminate against you for exercising any of your CCPA rights. <br />


      <!-- <div class="mb-5">
        <h2 class="h3 mb-1">Privacy Statement</h2>
        <p>This policy addresses how information obtained tbrough your use of web site is collected, stored, and used.
          The following topics are covered:</p>
        <ul class="list-bullet">
          <li>Collection and storage of technical information.</li>
          <li>Collection and storage of personal information.</li>
          <li>Collection and storage of account information.</li>
          <li>Disclosure of personal and account information.</li>
          <li>International Transactions</li>
          <li>Securing the web site.</li>
        </ul>
      </div>

      <div class="mb-5">
        <h2 class="h3 mb-1">Collection and Storage of Technical Information</h2>
        <p>Whenever you browse the web site or download forms, we collect and store information about your visit. This
          information does not identify you personally and consists of:</p>
        <ul class="list-bullet">
          <li>Your Internet protocol address. This is a numerical identifier assigned either to your Internet service
            provider or your computer. It can often be translated to determine the domain name of your service provider.
          </li>
          <li>The date and time of your first and last visit to this site.</li>
          <li>The web pages or services you accessed during your visit.</li>
        </ul>
      </div>

      <div class="mb-5">
        <h2 class="h3 mb-1">Collection and Storage of Personal Information</h2>
        <p>Certain personal information is required when you choose to submit a child support payment via our web site.
          This information is collected and stored and readily identifies you; for example, your name, address,
          telephone number, e-mail address, social security number, or case identifier.</p>
      </div>

      <div class="mb-5">
        <h2 class="h3 mb-1">Collection and Storage of Account Information</h2>
        <p>If you register for our bank draft service, the checking or savings account number that you provide is stored
          for processing purposes. If you choose to make a child support payment with your credit card, your card
          information is collected so we can process your payment, however it is not stored. If you choose to make
          another payment with your credit card at a future time, you will be required to resubmit your credit card
          information. The authorization number provided by your credit card company (when your payment is approved) is
          collected and stored.</p>
      </div>

      <div class="mb-5">
        <h2 class="h3 mb-1">Disclosure of Personal and Account Information</h2>
        <p>It is our policy to treat all personal and account information as confidential. However, we may disclose
          information to third parties about your account, or the transactions you make, in the following situations:
        </p>
        <ol class="list-decimal mb-3">
          <li>Where it is necessary for completing transactions, such as to the processing Financial Institution;
          </li>
          <li>In order to verify existence and condition of your account for a third party such as a credit bureau or
            merchant;</li>
          <li>If you give us your written permission; and</li>
          <li>Where required by law or in other appropriate circumstances.</li>
        </ol>
        <p>The personal information that you submit, such as a social security number, may become part of the child
          support file, however, all child support files are confidential.</p>
      </div>

      <div class="mb-5">
        <h2 class="h3 mb-1">International Transactions</h2>
        <p>All payments made tbrough this web site are intended only for payments not associated with a foreign bank
          account, which would classify it as an international ACH transaction (IAT).</p>
      </div>

      <div class="mb-5">
        <h2 class="h3 mb-1">
          Securing the Web Site</h2>
        <p>We have taken reasonable steps to safeguard the integrity of the data that we collect and store, along with
          preventing unauthorized access to information maintained by the web site. These measures are designed and
          intended to prevent corruption of data, block unknown or unauthorized access to our systems and information,
          and to provide reasonable protection of private information in our possession. Please be advised that, given
          the inherent nature of technology and the Internet, no security measures can ever be assumed to be 100%
          fail-safe.</p>
      </div>

      <div class="mb-5">
        <h2 class="h3 mb-1">
          Cookies</h2>
        <p>Cookies are very commonly used when browsing websites. It allows the website to store information on your
          computer in order to keep track of your unique session on the site. There are different types of cookies, and
          this site only uses a session cookie. Session cookies are stored temporarily and then deleted as soon as your
          web session has completed. It allows you to securely navigate the website using a unique session identifier,
          and the website is able to keep track of who you are. The storage of information related to the web session is
          temporary and the cookie will immediately be deleted as soon as you close or navigate away from the site. For
          security purposes, our website requires the use of session cookies.</p>
      </div> -->


    </div>
  </div>
</epay-page-content>
